import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ITravelPassAccountPayload } from "../../Orchestrator/Types/Interface/ITravelAccounts";

interface IGetTravelAccountsRequest {
  issuer: string;
  travelAccount: string;
}

export async function getTravelAccounts(request: IGetTravelAccountsRequest, showLoader?: boolean): Promise<IApiResponse<ITravelPassAccountPayload>> {
  const ENDPOINTS = await getEndpoints();
  let endpoint = ENDPOINTS.getTravelAccounts;
  endpoint += `?issuer=${request.issuer}&travelAccount=${request.travelAccount}`;

  return await apiRequest<ITravelPassAccountPayload>(endpoint, 'GET', {}, 'none', undefined, undefined, showLoader);
}
